import axios from "axios";
// import { REACT_APP_BACKEND_API } from "../constants";

const httpClient = axios.create({
  //  baseURL: `${REACT_APP_BACKEND_API}`,
  baseURL: `https://j72s7425if.execute-api.us-west-1.amazonaws.com`,
  headers: {
    "Content-type": "application/json",
  },
});

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // eslint-disable-next-line no-console
    console.log(error);
    return Promise.reject(error);
  }
);

export default httpClient;
